/*
 *   File : summary.js
 *   Author : https://evoqins.com
 *   Description : Dashboard Summary Card component
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

// Packages
import { Fragment, memo } from "react"
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";

const SummaryCard = (props) => {
    const navigate = useNavigate();
    return (
        <Fragment>
            <div className="bg-white border-radius-24px padding-32px-tb px-3 h-100 cursor-pointer"
                onClick={() => navigate(props.url, props.filter ? { state: props.filter } : undefined)}>
                <div className="d-flex align-items-center gap-8px mb-4">
                    <img src={props.icon}
                        alt={props.title}
                        width={32}
                        height={32}
                        draggable={false} />
                    <h6 className="color-dark-charcoal e-font-14 e-line-height-24 e-montserrat-medium mb-0">
                        {props.title}
                    </h6>
                </div>
                <span className=" color-dark-charcoal e-font-20 e-line-height-24 e-montserrat-semi-bold"
                    data-tooltip-id={props.title}>
                    {props.countText}
                </span>
                {
                    props.count &&
                    <Tooltip id={props.title}
                        className='e-summary-hover'>
                        <span className='color-white e-montserrat-regular e-font-12 e-line-height-18'>₹ {parseFloat(props.count).toLocaleString('en-IN')}</span>
                    </Tooltip>
                }
            </div>
        </Fragment>
    )
}

export default memo(SummaryCard);